import { z } from 'zod/mini'

/**
 * Landing banners stringify missing creative and position as `''`, and CMS
 * sliders fall back to `''` without a technical name.
 */
export const promotionSchema = z.strictObject({
  creative_name: z.string(),
  creative_slot: z.string(),
  promotion_id: z.optional(z.string()),
  promotion_name: z.optional(z.string()),
})
